import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GenericService} from './generic.service';
import {environment} from '../../../environments/environment';
import {catchError} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {Service} from '../models/assignment_service';
import {Establishment} from '../models/establishment';
import { Country } from '../models/Country';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService extends GenericService {

  constructor(private http: HttpClient, private storageService: StorageService) {
    super();
  }

  getAllCountries(congressId = null){
    const url = environment.baseUrl + "/countries?congressId=" + congressId;
    return this.http.get<Array<Country>>(url)
      .pipe(catchError(this.handleErrors));
  }

  uploadFile(file: File) {
    const data: FormData = new FormData();
    data.append('files', file, file.name);
    return this.http.post<any>(environment.baseUrl + '/files/upload-resource', data);
  }

  
  convertCurrencyRates(convertFrom, convertTo) {
    const url = environment.baseUrl + '/currency/convert-rates?convertFrom=' + convertFrom + '&convertTo=' + convertTo;
    return this.http.get(url);
  }

  getEtablissementByCongressId(congressId: number) {
    const headers = this.headers.set("Authorization", "Bearer " + this.storageService.read(StorageService.USER_TOKEN_KEY));
    const url = environment.baseUrl + '/congress/' + congressId + '/etablissements/all';
    return this.http.get<Establishment[]>(url,{ headers: headers });
  }

  getEtablissementByCongressIdPublic(congressId: number) {
    const headers = this.headers.set("Authorization", "Bearer " + this.storageService.read(StorageService.USER_TOKEN_KEY));
    const url = environment.baseUrl + '/congress/' + congressId + '/etablissements/all/public';
    return this.http.get<Establishment[]>(url, { headers: headers });
  }

  getServiceByCongressId(congressId: number) {
    const headers = this.headers.set("Authorization", "Bearer " + this.storageService.read(StorageService.USER_TOKEN_KEY));
    const url = environment.baseUrl + '/congress/' + congressId + '/services/all';
    return this.http.get<Service[]>(url,{ headers: headers });
  }

  getServiceByCongressIdPublic(congressId: number) {
    const headers = this.headers.set("Authorization", "Bearer " + this.storageService.read(StorageService.USER_TOKEN_KEY));
    const url = environment.baseUrl + '/congress/' + congressId + '/services/all/public';
    return this.http.get<Service[]>(url, { headers: headers });
  }

  convertCurrencyRates2() {
    const url = 'https://openexchangerates.org/api/latest.json?app_id='+ environment.changerates
    return this.http.get(url);
  }

  storeNewLogs(congress_id: number, form_id: number) {
      const url = environment.baseUrl + '/logs/store-logs';
      return this.http.post(url, {"congress_id": congress_id, "form_id": form_id});
  }

  updateLog(congress_id: number, form_id: number, completed_step_key: string, user: any, storage: any) {
    let body;
    if (completed_step_key == 'basic_infos_step') {
      body = {
        congress_id: congress_id,
        form_id: form_id,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        mobile: user.mobile,
        gender: user.gender,
        country_id: user.country_id,
        completed_step_key: completed_step_key
      };
    } else {
      body = {
        congress_id: congress_id,
        form_id: form_id,
        email: user.email,
        storage: storage,
        completed_step_key: completed_step_key
      };
    }
    const url = environment.baseUrl + '/logs/update-logs';
    return this.http.post(url, body);
  }

  addStat(congress_id, form_id, errorType){
    const url = environment.baseUrl + "/congress/" + congress_id +"/dashboard-stats/set-dashboard-stats";
    return this.http.post(url, {form_id : form_id, error_type: errorType});
}

  loadDataFromLocalStorage(congressId, formId, dataKey) {
    const savedData: any[] = this.storageService.read('form-data') || [];
    if (savedData) {
      const filteredData = savedData.find((entry: any) =>
        entry.congress_id === congressId && entry.form_id === formId
      );

      if (filteredData) {
        return filteredData[dataKey];
      }else{
        return null;
      }
    }
  }
  saveData(congressId, formId, dataKey, data) {
    let savedData: any[] = this.storageService.read('form-data') || [];

    const existingDataIndex = savedData.findIndex((entry: any) =>
      entry.congress_id === congressId && entry.form_id === formId
    );

    if (existingDataIndex !== -1) {
      savedData[existingDataIndex][dataKey] = data;
    } else {
      const newData = {
        congress_id: congressId,
        form_id: formId,
        [dataKey]: data
      };
      savedData.push(newData);
    }
    this.storageService.write('form-data', savedData);
  }
  convertStringsToInts(list) {
    return list.map(item => parseInt(item, 10));
  }
}
